var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___QkZlWk",
  "cU": "UserArea.module__userAreaContainer___QkZlWk",
  "jC": "UserArea.module__popoutContainer___QkZlWk",
  "oT": "UserArea.module__voiceConnectionWrapper___QkZlWk",
  "eF": "UserArea.module__userInfo___QkZlWk",
  "vu": "UserArea.module__active___QkZlWk",
  "N6": "UserArea.module__userInfoText___QkZlWk",
  "nT": "UserArea.module__userName___QkZlWk",
  "ag": "UserArea.module__userStatus___QkZlWk",
  "uh": "UserArea.module__userStatusLabel___QkZlWk" + " " + "UserArea.module__userStatus___QkZlWk",
  "XW": "UserArea.module__userCustomStatus___QkZlWk" + " " + "UserArea.module__userStatus___QkZlWk",
  "oM": "UserArea.module__hoverRoll___QkZlWk",
  "n6": "UserArea.module__defaultState___QkZlWk",
  "yo": "UserArea.module__hovered___QkZlWk",
  "EE": "UserArea.module__forceHover___QkZlWk",
  "gO": "UserArea.module__controlsContainer___QkZlWk",
  "uH": "UserArea.module__controlButton___QkZlWk",
  "DY": "UserArea.module__contextMenuHover___QkZlWk",
  "r9": "UserArea.module__disabled___QkZlWk",
  "pd": "UserArea.module__controlIcon___QkZlWk",
  "se": "UserArea.module__controlIconWithDot___QkZlWk",
  "PP": "UserArea.module__controlDot___QkZlWk",
};

module.exports = exports;
